
import service from './service.js'

export function fetchPost(url, params) {
  let sid = ''
  if (params.site_id) {
    sid = params.site_id
  } else {
    sid = sessionStorage.getItem('sId')
  }
  Object.assign(params, {
    site_id: sid
  })
  return new Promise((resolve, reject) => {
    service.post(url, params)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export function fetchGet(url, param) {
  return new Promise((resolve, reject) => {
    service.get(url, { params: param })
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
      .catch((error) => {
        reject(error)
      })
  })
}


// WEBPACK FOOTER //
// ./src/utils/api.js